import React, { useContext } from "react";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

export default function Diagnosticos() {
  const {
    diagnosticos,
    obtenerDiagnosticos,
    agregarDiagnostico,
    actualizarDiagnostico,
  } = useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Diagnósticos"
      entidad="diagnóstico"
      layout="Diagnosticos"
      icono={<FactCheckOutlinedIcon />}
      items={diagnosticos}
      onObtener={() => obtenerDiagnosticos({ todos: true })}
      onAgregar={(data) => agregarDiagnostico({ diagnostico: data })}
      onActualizar={(data) => actualizarDiagnostico({ diagnostico: data })}
    />
  );
}
